export default "__VITE_ASSET__DdShNYJG__"